module.exports = __webpack_public_path__ + "img/00_Habilitaciones - ANMAT.7030d255.jpg";